import UserRoleEnum from "../Enums/UserRoleEnum";

export const homeMenuItems = [
  {
    label: "Dodaj wycieczkę",
    path: "popup:add-trip",
    icon: "FaSuitcaseRolling",
    roles: [UserRoleEnum.ADMIN, UserRoleEnum.COORDINATOR, UserRoleEnum.SYSTEM_ADMIN]
  },
  {
    label: "Użytkownicy",
    path: "/users",
    icon: "FaUsers",
    roles: [UserRoleEnum.ADMIN, UserRoleEnum.SYSTEM_ADMIN]
  },
  {
    label: "Widoki specjalne",
    path: "/views",
    icon: "FaThLarge",
    roles: [UserRoleEnum.FINANCE, UserRoleEnum.ADMIN, UserRoleEnum.COORDINATOR, UserRoleEnum.BOARD, UserRoleEnum.MENTOR, UserRoleEnum.SOLIDARITY_FUND, UserRoleEnum.SYSTEM_ADMIN]
  }
];
